// iframe API
const post = (data: Object, targetOrigin: ?string) => {
    const target = window.parent;
    const origin = targetOrigin || '*';

    target.postMessage(data, origin);
};

export { post };
